import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M13.0133 13.0014H19.0033C19.0033 17.9421 14.5208 21.8427 9.39929 20.8425C6.28446 20.2325 3.76865 17.7221 3.15966 14.6017C2.16132 9.48092 5.97498 5.00028 10.9667 5.00028V11.0011C10.9767 12.1113 11.9151 13.0014 13.0133 13.0014ZM15.01 11.0011H21C21 6.58052 16.9667 3 12.9733 3V9.00085C12.9733 10.111 13.9118 11.0011 15.01 11.0011Z' />
        </SvgIcon>
    );
});
